import React from 'react';
import styled from 'styled-components/macro';

import { OpenConvalidaInfoResponse } from 'models/response';

import utils from 'utils';

import Dropdown from 'components/Input/dropdown/Dropdown';

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 35px 0;
  > div {
    margin-right: 5px;
  }
`;

interface Props {
  response: OpenConvalidaInfoResponse;
}

const Close = (props: Props) => {
  const { response } = props;
  const t = utils.intl.useTranslator();

  return (
    <SelectWrapper>
      <div>{t('destinatario')}: </div>
      <div>
        <Dropdown
          id="user-dropdown"
          name="user"
          disabled={true}
          value={{
            label: response.finalDestinationUser?.name,
            value: response.finalDestinationUser?.idUser,
          }}
          options={[
            {
              label: response.finalDestinationUser?.name,
              value: response.finalDestinationUser?.idUser,
            },
          ]}
        />
      </div>
    </SelectWrapper>
  );
};

export default Close;
